import { render } from "./CApi.vue?vue&type=template&id=4b3af401"
import script from "./CApi.vue?vue&type=script&lang=js"
export * from "./CApi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__